import React from 'react';
import Layout from "../components/layout";
import Breadcrumb from '../components/breadcrumb';
import '../components/button/_button.scss';
import { Accordion, Card } from 'react-bootstrap';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
library.add(faPlus, faMinus);


class RoadmapPage extends React.Component {
	render() {

		return (
			<Layout >
				<main className="container-fluid">
					<Breadcrumb title="Roadmap" />
					<div className="row">
						<div className="col-md-10 col">
							<p>
								The following list entails features or developments that are planned for the future of Fantasy Franchise. This roadmap is subject to change, and does not include every feature or development that Fantasy Franchise will see.
							</p>
							<p>
								Release dates cannot be given for any item listed below.
							</p>

						

							<Accordion className="accordion">
								<Card>
									<Accordion.Collapse eventKey="1" className="goal-answer">
										<Card.Body>
											<ul>
												<li><del>ESPN</del></li>
												<li>Yahoo</li>
												<li><del>Sleeper</del></li>
												<li>Myfantasyleague</li>
											</ul>
										</Card.Body>
									</Accordion.Collapse>
									<Accordion.Toggle as={Card.Header} eventKey="1" className="goal">
										<FontAwesomeIcon icon="minus" className="mr-3" /><FontAwesomeIcon icon="plus" className="mr-3" />
										Compatibility with other Fantasy Providers
									</Accordion.Toggle>
								</Card>
								<Card>
									<Accordion.Collapse eventKey="2" className="goal-answer">
										<Card.Body>
											<ul>
												<li><del>Top 10 scores</del></li>
												<li><del>Bottom 10 scores</del></li>
												<li><del>Top 10 highest victory margins</del></li>
												<li><del>Top 10 lowest victory margins</del></li>
												<li><del>Top 10 most combined points</del></li>
												<li><del>Top 10 fewest combined points</del></li>
												<li><del>Top 10 higest score in a loss </del></li>
												<li><del>Top 10 lowest score in a win </del></li>
											</ul>
										</Card.Body>
									</Accordion.Collapse>
									<Accordion.Toggle as={Card.Header} eventKey="2" className="goal">
										<FontAwesomeIcon icon="minus" className="mr-3" /><FontAwesomeIcon icon="plus" className="mr-3" />
										Game Records
									</Accordion.Toggle>
								</Card>
								<Card>
									<Accordion.Collapse eventKey="3" className="goal-answer">
										<Card.Body>
											<ul>
												<li><del>Top 10 most wins in a season</del></li>
												<li><del>Top 10 most losess in a season</del></li>
												<li><del>Top best winning pct in a season</del></li>
												<li><del>Top worst winning pct in a season</del></li>
												<li><del>Top 10 highest scoring teams in a season</del></li>
												<li><del>Top 10 lowest scoring teams in a season</del></li>
												<li><del>Top 10 highest average fantasy points per game in a season</del></li>
												<li><del>Top 10 lowest average fantasy points per game in a season</del></li>
												<li>Top 10 win streaks within a season</li>
												<li>Top 10 lossing streaks within a season</li>
												<li>Top 10 win streaks all time</li>
												<li>Top 10 lossing streaks all time</li>
											</ul>
										</Card.Body>
									</Accordion.Collapse>
									<Accordion.Toggle as={Card.Header} eventKey="3" className="goal">
										<FontAwesomeIcon icon="minus" className="mr-3" /><FontAwesomeIcon icon="plus" className="mr-3" />
										Season records
									</Accordion.Toggle>
								</Card>
								<Card>
									<Accordion.Collapse eventKey="3" className="goal-answer">
										<Card.Body>
											<ul>
												<li>Top win streaks all time</li>
												<li>Top lossing streaks all time</li>
											</ul>
										</Card.Body>
									</Accordion.Collapse>
									<Accordion.Toggle as={Card.Header} eventKey="3" className="goal">
										<FontAwesomeIcon icon="minus" className="mr-3" /><FontAwesomeIcon icon="plus" className="mr-3" />
										All time records
									</Accordion.Toggle>
								</Card>
								<Card>
									<Accordion.Collapse eventKey="11" className="goal-answer">
										<Card.Body>
											<ul>
												<li>Most championships</li>
												<li>Most championships appearances</li>
												<li>Top 10 playoffs appearances</li>
												<li>Top 10 playoffs wins</li>
												<li>Top 10 playoffs loses</li>
												<li>Top 10 playoffs streaks</li>
												<li>Top 10 playoffs draughts</li>
											</ul>
										</Card.Body>
									</Accordion.Collapse>
									<Accordion.Toggle as={Card.Header} eventKey="11" className="goal">
										<FontAwesomeIcon icon="minus" className="mr-3" /><FontAwesomeIcon icon="plus" className="mr-3" />
										All-time playoffs Records
									</Accordion.Toggle>
								</Card>
								<Card>
									<Accordion.Collapse eventKey="4" className="goal-answer">
										<Card.Body>
											<ul>
												<li>QB, Most Points (season/game)</li>
												<li>WR, Most Points (season/game)</li>
												<li>RB, Most Points (season/game)</li>
												<li>TE, Most Points (season/game)</li>
												<li>D/ST, Most Points (season/game)</li>
												<li>K, Most Points (season/game)</li>
											</ul>
										</Card.Body>
									</Accordion.Collapse>
									<Accordion.Toggle as={Card.Header} eventKey="4" className="goal">
										<FontAwesomeIcon icon="minus" className="mr-3" /><FontAwesomeIcon icon="plus" className="mr-3" />
										Player records
									</Accordion.Toggle>
								</Card>
								<Card>
									<Accordion.Collapse eventKey="5" className="goal-answer">
										<Card.Body>
											<ul>
												<li>QB, Most Points (season/game/all time)</li>
												<li>WR, Most Points (season/game/all time)</li>
												<li>RB, Most Points (season/game/all time)</li>
												<li>TE, Most Points (season/game/all time)</li>
												<li>D/ST, Most Points (season/game/all time)</li>
												<li>K, Most Points (season/game/all time)</li>
											</ul>
										</Card.Body>
									</Accordion.Collapse>
									<Accordion.Toggle as={Card.Header} eventKey="5" className="goal">
										<FontAwesomeIcon icon="minus" className="mr-3" /><FontAwesomeIcon icon="plus" className="mr-3" />
										Franchise Player records
									</Accordion.Toggle>
								</Card>
								<Card>
									<Accordion.Collapse eventKey="6" className="goal-answer">
										<Card.Body>
											<ul>
												<li>Final rosters for every year</li>
												<li>Initial rosters at the start of every year</li>
												<li>Roster for every week of every year</li>
											</ul>
										</Card.Body>
									</Accordion.Collapse>
									<Accordion.Toggle as={Card.Header} eventKey="6" className="goal">
										<FontAwesomeIcon icon="minus" className="mr-3" /><FontAwesomeIcon icon="plus" className="mr-3" />
											Rosters
									</Accordion.Toggle>
								</Card>
								<Card>
									<Accordion.Collapse eventKey="7" className="goal-answer">
										<Card.Body>
											<ul>
												<li>All gamelogs including players data</li>
												<li>Search gamelog by week and year</li>
												<li>Search gamelog by team</li>
											</ul>
										</Card.Body>
									</Accordion.Collapse>
									<Accordion.Toggle as={Card.Header} eventKey="7" className="goal">
										<FontAwesomeIcon icon="minus" className="mr-3" /><FontAwesomeIcon icon="plus" className="mr-3" />
										Game logs
									</Accordion.Toggle>
								</Card>
								<Card>
									<Accordion.Collapse eventKey="8" className="goal-answer">
										<Card.Body>
											<ul>
												<li>All drafts for every year</li>
												<li>Search draft year</li>
												<li>Search draft by team</li>
												<li>Search draft by round</li>
											</ul>
										</Card.Body>
									</Accordion.Collapse>
									<Accordion.Toggle as={Card.Header} eventKey="8" className="goal">
										<FontAwesomeIcon icon="minus" className="mr-3" /><FontAwesomeIcon icon="plus" className="mr-3" />
										Draft
									</Accordion.Toggle>
								</Card>
								<Card>
									<Accordion.Collapse eventKey="9" className="goal-answer">
										<Card.Body>
											<p>Complete trade log with analysis of potential points (points scored by players regardless if they were played) and actual points (only take into account players that got aligned in the starting roster)</p>
											<ul>
												<li>Top 10 most lopsided trades</li>
												<li>Top 10 most even trades</li>
											</ul>
										</Card.Body>
									</Accordion.Collapse>
									<Accordion.Toggle as={Card.Header} eventKey="9" className="goal">
										<FontAwesomeIcon icon="minus" className="mr-3" /><FontAwesomeIcon icon="plus" className="mr-3" />
										Trades
									</Accordion.Toggle>
								</Card>
								<Card>
									<Accordion.Collapse eventKey="10" className="goal-answer">
										<Card.Body>
											<ul>
												<li>Power Rankings</li>
												<li>Playoff Odds</li>
												<li>Designs/Skins</li>
												<li>Add consolation brackets to records</li>
											</ul>
										</Card.Body>
									</Accordion.Collapse>
									<Accordion.Toggle as={Card.Header} eventKey="10" className="goal">
										<FontAwesomeIcon icon="minus" className="mr-3" /><FontAwesomeIcon icon="plus" className="mr-3" />
										Misc
									</Accordion.Toggle>
								</Card>
							</Accordion>

							<p className="my-3">
								If you have an interest in helping support the site, please use please use Zelle (Preferred no transaction fees), Paypal, or Patreon buttons.<br /><br />
								I'm also a Freelance Web Developer you can check out my work at <a href="https://squidsource.com/" target="_blank" rel="noopener noreferrer">https://squidsource.com/</a>
							</p>
							<img className="mr-2" src="https://www.zellepay.com/sites/default/files/zelle%20logo%20card_0.jpg" width="100" alt="Zelle" /> fabianbrenes [at] gmail [dot] com

							<a className="bmc-button my-3" target="_blank" href="https://www.paypal.com/paypalme2/FabianBrenes" rel="noopener noreferrer">
								<img className="mr-2" src="https://www.paypalobjects.com/webstatic/icon/pp258.png" width="40" alt="Paypal.me" />
								<span>Paypal Me</span>
							</a>

							<a className="bmc-button my-3" target="_blank" rel="noopener noreferrer" href="https://www.patreon.com/bePatron?u=13567542" data-patreon-widget-type="become-patron-button">
								<img className="mr-2" src="https://fantasy-franchise.com/img/patreon.jpg" width="40" alt="Patreon" />
									Become a Patron!
								</a>
						</div>
					</div>

				</main>
			</Layout>
			);
	}
}
export default RoadmapPage;


